const axios = require('axios');
let host = (window.location.host.startsWith('localhost') ? 'localhost:8080' : 'api.servercraft.dk');
let protocol = window.location.protocol;
let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
};

let SubscriptionSource = {
    addSubscription: function (email, name) {
        return new Promise(function (resolve, reject) {
            axios.post(protocol + '//' + host + '/subscribe',
                {
                    email: email,
                    name: name
                }
                , axiosConfig)
                .then(resolve)
                .catch(reject);
        });
    }
};

module.exports = SubscriptionSource;


// WEBPACK FOOTER //
// ./src/source/SubscriptionSource.jsx